import { utilities as csUtils } from '@cornerstonejs/core';
import { getBoundingBoxAroundShape } from '../../../utilities/boundingBox';
import { pointInShapeCallback } from '../../../utilities';
import { triggerSegmentationDataModified } from '../../../stateManagement/segmentation/triggerSegmentationEvents';
import { getStrategyData } from './utils/getStrategyData';
const { transformWorldToIndex } = csUtils;
function fillRectangle(enabledElement, operationData, inside = true) {
    const { points, segmentsLocked, segmentIndex, segmentationId, constraintFn } = operationData;
    const strategyData = getStrategyData({
        operationData,
        viewport: enabledElement.viewport,
    });
    if (!strategyData) {
        console.warn('No data found for fillRectangle');
        return;
    }
    const { segmentationImageData, segmentationScalarData } = strategyData;
    let rectangleCornersIJK = points.map((world) => {
        return transformWorldToIndex(segmentationImageData, world);
    });
    rectangleCornersIJK = rectangleCornersIJK.map((point) => {
        return point.map((coord) => {
            return Math.round(coord);
        });
    });
    const boundsIJK = getBoundingBoxAroundShape(rectangleCornersIJK, segmentationImageData.getDimensions());
    const pointInRectangle = () => true;
    const callback = ({ value, index, pointIJK }) => {
        if (segmentsLocked.includes(value)) {
            return;
        }
        if (!constraintFn) {
            segmentationScalarData[index] = segmentIndex;
            return;
        }
        if (constraintFn(pointIJK)) {
            segmentationScalarData[index] = segmentIndex;
        }
    };
    pointInShapeCallback(segmentationImageData, pointInRectangle, callback, boundsIJK);
    triggerSegmentationDataModified(segmentationId);
}
export function fillInsideRectangle(enabledElement, operationData) {
    fillRectangle(enabledElement, operationData, true);
}
export function fillOutsideRectangle(enabledElement, operationData) {
    fillRectangle(enabledElement, operationData, false);
}
//# sourceMappingURL=fillRectangle.js.map